import * as Accordion from '@radix-ui/react-accordion';
import { cn } from '@/utils/cn';

interface FilterSectionProps {
  title: string;
  value: string;
  children: React.ReactNode;
  headerAction?: React.ReactNode;
}

/**
 * Collapsible filter section
 * Must be used within an Accordion.Root component
 */
export function FilterSection({
  title,
  value,
  children,
  headerAction,
}: FilterSectionProps) {
  return (
    <Accordion.Item value={value}>
      <Accordion.Header className="flex items-center gap-2">
        <Accordion.Trigger
          className={cn(
            'flex flex-1 items-center justify-between py-4 text-left',
            'hover:bg-ink/5 -mx-2 px-2 rounded-lg transition-colors',
            'group'
          )}
        >
          <span className="font-semibold text-ink">{title}</span>
          <svg
            className={cn(
              'h-5 w-5 text-muted transition-transform duration-200',
              'group-data-[state=open]:rotate-180'
            )}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </Accordion.Trigger>
        {headerAction && <div className="pr-2">{headerAction}</div>}
      </Accordion.Header>
      <Accordion.Content className="overflow-hidden data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up">
        <div className="pb-6">{children}</div>
      </Accordion.Content>
    </Accordion.Item>
  );
}
